import React, { useState } from 'react';
import { useTheme } from '@/managers/ThemeProvider';

export const CatLogo = ({
  size = 32,
  strokeWidth = 1.5,
  className = "",
  animated = false,
  gradient = false,
  withText = false,
  alwaysShowText = false,
  centered = false,
  forceColorClass = null, // New prop to allow external color override
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const { currentTheme } = useTheme();

  const isLightVariant = parseInt(currentTheme) >= 11;
  // Core color logic: use forced class if provided, otherwise follow theme
  const colorClass = forceColorClass
    ? forceColorClass
    : (isLightVariant ? 'text-primary-dark' : 'text-primary');
  const defaultClasses = `${colorClass} transition-colors duration-200 hover:text-primary-light`;
  const combinedClasses = `${defaultClasses} ${className}`.trim();

  if (!withText) {
    return (
      <div className="p-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          className={combinedClasses}
        >
          <path className="cat-body" d="M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3.1-9-7.56c0-1.2.43-2.37 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z"/>
          <path className="cat-eyes" d="M8 14v.5" />
          <path className="cat-eyes" d="M16 14v.5" />
          <path className="cat-nose" d="M11.25 16.25h1.5L12 17l-.75-.75Z" />
        </svg>
      </div>
    );
  }

  // Determine if text should be shown (either from hover state or alwaysShowText prop)
  const showText = isHovered || alwaysShowText;

  // For centered layout with always-visible text
  if (centered && alwaysShowText) {
    return (
      <div className="flex flex-col items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          className={combinedClasses}
        >
          <path className="cat-body" d="M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3.1-9-7.56c0-1.2.43-2.37 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z"/>
          <path className="cat-eyes" d="M8 14v.5" />
          <path className="cat-eyes" d="M16 14v.5" />
          <path className="cat-nose" d="M11.25 16.25h1.5L12 17l-.75-.75Z" />
        </svg>
        <span className={`
          ${colorClass}
          font-bold 
          text-base
          tracking-wide 
          hover:text-primary-light
          uppercase
          mt-2
        `}>
          Shelbula
        </span>
      </div>
    );
  }

  // Standard inline layout with hover effect
  return (
    <div 
      className="relative inline-flex items-center h-[50px]"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="pl-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          className={combinedClasses}
        >
          <path className="cat-body" d="M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3.1-9-7.56c0-1.2.43-2.37 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z"/>
          <path className="cat-eyes" d="M8 14v.5" />
          <path className="cat-eyes" d="M16 14v.5" />
          <path className="cat-nose" d="M11.25 16.25h1.5L12 17l-.75-.75Z" />
        </svg>
      </div>

      <div 
        className={`
          absolute left-[calc(100%+0.5rem)]
          whitespace-nowrap 
          overflow-hidden
          transition-all 
          duration-300 
          ease-out
          ${showText ? 'w-[90px] opacity-100' : 'w-0 opacity-0'}
        `}
      >
        <span className={`
          ${colorClass}
          font-bold 
          text-base
          tracking-wide 
          hover:text-primary-light
          uppercase
        `}>
          Shelbula
        </span>
      </div>
    </div>
  );
};